import React from "react";

export const appCtx = React.createContext();
export const AppProvider = appCtx.Provider;